module.exports = __webpack_public_path__ + "static/media/Dev.92f2d6c4.jpg";